export default __webpack_public_path__ + "static/IBMPlexSans-Italic-Greek-22d503c8b81adcc187a595c582ba8bb9.woff";